import { ExpertSpecialization } from '@packages/shared/core/experts/entities';
import styles from './ExpertCardSkills.module.scss';

export type ExpertCardSkillsProps = {
  className?: string;
  specializations: Array<ExpertSpecialization>;
  skillsLimit?: number;
};

export const ExpertCardSkills = ({
  className = '',
  specializations,
  skillsLimit = specializations.length,
}: ExpertCardSkillsProps) => {
  return (
    <div className={className}>
      <p className={styles.title}>Fields of expertise:</p>

      <ul className={styles.list}>
        {specializations.slice(0, skillsLimit).map(({ name, id }) => (
          <li className={styles.item} key={id}>
            {name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ExpertCardSkills;
